export default "__VITE_ASSET__0345f71c__"